import React, { useEffect, useState, } from "react";
import { Container, Row, Col, Table, Accordion, Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import blogs from "./Blogs";
import BlogHero from "./BlogHero";
import { Link } from "react-router";

export default function BlogDetails() {
    const { slug } = useParams();

    const blog = blogs.find(
        (item) => item.slug === slug
    );

    const [activeTab, setActiveTab] =
        useState("");

    // ACTIVE TAB ON SCROLL
    useEffect(() => {
        if (!blog) return;

        const handleScroll = () => {
            blog.sections.forEach((section) => {
                const el = document.getElementById(
                    section.id
                );

                if (el) {
                    const top =
                        el.offsetTop - 140;

                    const bottom =
                        top + el.offsetHeight;

                    if (
                        window.scrollY >= top &&
                        window.scrollY < bottom
                    ) {
                        setActiveTab(section.id);
                    }
                }
            });
        };

        window.addEventListener(
            "scroll",
            handleScroll
        );

        handleScroll();

        return () =>
            window.removeEventListener(
                "scroll",
                handleScroll
            );
    }, [blog]);

    // SCROLL TO SECTION
    const scrollToSection = (id) => {
        const el =
            document.getElementById(id);

        if (el) {
            window.scrollTo({
                top: el.offsetTop - 100,
                behavior: "smooth",
            });
        }
    };

    if (!blog) {
        return <h2>Blog not found</h2>;
    }

    return (
        <section className="blog-detail-page py-5">
            <BlogHero blog={blog} />
            <Container className="mt-4">
                <Link to="/blogs">
                    <Button
                        variant="outline-dark"
                        className="rounded-pill mb-4"
                    >
                        ← Back
                    </Button>
                </Link>
                <Row>
                    {/* SIDEBAR */}
                    <Col lg={3}>
                        <div className="sidebar-tabs">
                            <h5 className="sidebar-title">
                                Table of contents
                            </h5>

                            <ul>
                                {blog.sections.map(
                                    (section) => (
                                        <li
                                            key={section.id}
                                            className={
                                                activeTab ===
                                                    section.id
                                                    ? "active"
                                                    : ""
                                            }
                                            onClick={() =>
                                                scrollToSection(
                                                    section.id
                                                )
                                            }
                                        >
                                            {section.title}
                                        </li>
                                    )
                                )}
                            </ul>
                        </div>
                    </Col>

                    {/* CONTENT */}
                    <Col lg={9}>
                        {/* HERO IMAGE */}
                        <div className="hero-wrapper">
                            <img
                                src={blog.image}
                                alt={blog.title}
                                className="img-fluid"
                            />
                        </div>

                        {/* SECTIONS */}
                        {blog.sections.map(
                            (section) => (
                                <section
                                    id={section.id}
                                    key={section.id}
                                    className="content-section"
                                >
                                    <h4 className="heading-style-h4 pt-5">{section.title}</h4>

                                    {/* CONTENT */}
                                    {section.content && (
                                        <p>{section.content}</p>
                                    )}

                                    {/* UL LI LIST */}
                                    {section.list && (
                                        <ul>
                                            {section.list.map((item, index) => (
                                                <li key={index}>
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    )}

                                    {/* highlightText */}
                                    {section.highlightText && (
                                        <p>{section.highlightText}</p>
                                    )}

                                    {/* bottomContent */}
                                    {section.bottomContent && (
                                        <p>{section.bottomContent}</p>
                                    )}

                                    {/* SUB SECTIONS */}
                                    {section.subSections &&
                                        section.subSections.map(
                                            (
                                                sub,
                                                index
                                            ) => (
                                                <div
                                                    key={index}
                                                >
                                                    <h4 className="heading-style-h4">
                                                        {
                                                            sub.heading
                                                        }
                                                    </h4>

                                                    {sub.text
                                                        .trim()
                                                        .split("\n")
                                                        .map(
                                                            (
                                                                line,
                                                                i
                                                            ) => (
                                                                <p
                                                                    key={
                                                                        i
                                                                    }
                                                                >
                                                                    {
                                                                        line
                                                                    }
                                                                </p>
                                                            )
                                                        )}
                                                </div>
                                            )
                                        )}

                                    {/* TABLE */}
                                    {section.table && (
                                        <div className="table-wrapper">
                                            <Table
                                                bordered
                                                responsive
                                            >
                                                <thead>
                                                    <tr>
                                                        {section.table.headers.map(
                                                            (
                                                                header,
                                                                index
                                                            ) => (
                                                                <th
                                                                    key={
                                                                        index
                                                                    }
                                                                >
                                                                    {
                                                                        header
                                                                    }
                                                                </th>
                                                            )
                                                        )}
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {section.table.rows.map(
                                                        (
                                                            row,
                                                            index
                                                        ) => (
                                                            <tr
                                                                key={
                                                                    index
                                                                }
                                                            >
                                                                {row.map(
                                                                    (
                                                                        cell,
                                                                        cellIndex
                                                                    ) => (
                                                                        <td
                                                                            key={
                                                                                cellIndex
                                                                            }
                                                                        >
                                                                            {
                                                                                cell
                                                                            }
                                                                        </td>
                                                                    )
                                                                )}
                                                            </tr>
                                                        )
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    )}

                                    {/* CARD */}
                                    {
                                        section.type ===
                                        "comparisonCard" && (
                                            <div className="delivery-comparison-card">
                                                <h2 className="comparison-title">
                                                    {section.title}
                                                </h2>

                                                <div className="comparison-table">
                                                    {/* HEADER */}
                                                    <div className="comparison-row comparison-header">
                                                        <div className="comparison-col factor">
                                                            {section.headers.factor}
                                                        </div>

                                                        <div className="comparison-col inhouse">
                                                            {
                                                                section.headers.inHouse
                                                            }
                                                        </div>

                                                        <div className="comparison-col offshore active-col">
                                                            {
                                                                section.headers
                                                                    .offshore
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* ROWS */}
                                                    {section.rows.map(
                                                        (row, index) => (
                                                            <div
                                                                className="comparison-row"
                                                                key={index}
                                                            >
                                                                <div className="comparison-col factor">
                                                                    {row.factor}
                                                                </div>

                                                                <div className="comparison-col inhouse">
                                                                    {row.inHouse ? (
                                                                        <span className="check-icon white-check">
                                                                            ✓
                                                                        </span>
                                                                    ) : (
                                                                        "—"
                                                                    )}
                                                                </div>

                                                                <div className="comparison-col offshore active-col">
                                                                    {row.offshore ? (
                                                                        <span className="check-icon">
                                                                            ✓
                                                                        </span>
                                                                    ) : (
                                                                        "—"
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }
                                </section>
                            )
                        )}

                        {/* CTA */}
                        <div className="cta-section">
                            <h2>{blog.cta.title}</h2>

                            <button>
                                {blog.cta.buttonText}
                            </button>
                        </div>

                        {/* FAQ */}
                        <section className="content-section">
                            <h2>
                                Frequently Asked Questions
                            </h2>

                            <Accordion flush>
                                {blog.faq.map(
                                    (item, index) => (
                                        <Accordion.Item
                                            eventKey={index.toString()}
                                            key={index}
                                        >
                                            <Accordion.Header>
                                                {item.question}
                                            </Accordion.Header>

                                            <Accordion.Body>
                                                {item.answer}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )
                                )}
                            </Accordion>
                        </section>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}